import { render, staticRenderFns } from "./FreeTextFeedback.vue?vue&type=template&id=0404569c&scoped=true&lang=pug"
import script from "./FreeTextFeedback.vue?vue&type=script&lang=ts"
export * from "./FreeTextFeedback.vue?vue&type=script&lang=ts"
import style0 from "./FreeTextFeedback.vue?vue&type=style&index=0&id=0404569c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0404569c",
  null
  
)

export default component.exports